// このファイルは scripts/renewal/gen_site.py でモックアップから生成した。
// 文言・構成を直すときは、このファイルを直接編集してよい（再生成はしない）。
import { Link } from "react-router-dom";
import ContactBand from "../../ContactBand";

export default function CaseKidsArt() {
  return (
    <main>
      <section className="page-hero ground cd-hero" data-en="WORKS">
        <div className="container">
          <nav className="breadcrumb">
            <Link to="/">トップ</Link>
            <Link to="/cases">実績・事例</Link>
            <span>卒園児の絵のNFT</span>
          </nav>
          <div className="case-tags cd-tags">
            <span>教育・保育</span>
            <span>ブロックチェーン事業開発</span>
          </div>
          <h1 className="cd-title">
            卒園児が描いた絵を、「この世にひとつ」のデジタル絵として残す
          </h1>
          <p className="cd-client">鉄道グループの保育・教育事業会社</p>
          <div className="cd-img is-cover">
            <span className="cover-en">DIGITAL ART NFT</span>
            <span className="cover-ja">卒園記念 × NFT</span>
          </div>
          <div className="cd-summary">
            <div>
              <span>課題</span>
              <p>
                園で過ごした思い出を、なくさずに残せる形で卒園児に届けたい。
              </p>
            </div>
            <div>
              <span>解決策</span>
              <p>
                描いた絵を動きのあるデジタル絵にし、NFTとして保護者に届ける仕組み。
              </p>
            </div>
            <div>
              <span>成果</span>
              <p>
                オンラインでの展覧会を経て、家族がいつまでも持ち続けられる思い出に。
              </p>
            </div>
          </div>
        </div>
      </section>
      <section className="section">
        <div className="cd-body container">
          <section className="cd-sec">
            <h2>プロジェクト概要</h2>
            <p>
              保育園の年長クラスの園児が描いた絵をデジタル化し、動きを加えて「この世にひとつ」のデジタル絵（NFT）にする卒園記念の企画です。オンラインで一定期間展示したあと、保護者のウォレットに返却し、家族で持ち続けられるようにしました。
            </p>
          </section>
          <section className="cd-sec">
            <h2>お客様の課題</h2>
            <ul className="cd-list">
              <li>
                子どもが描いた絵は、成長とともになくしたり捨ててしまったりしやすい
              </li>
              <li>
                写真のようにコピーできる形ではなく、本物と同じく「ひとつだけ」の形で残したかった
              </li>
              <li>
                これからの社会で身近になる技術に、遊びの感覚で触れる機会をつくりたかった
              </li>
            </ul>
          </section>
          <section className="cd-sec">
            <h2>LEAPSの対応</h2>
            <div className="cd-point">
              <span className="cd-num">01</span>
              <div>
                <p className="cd-cat">デジタル化</p>
                <h3 className="cd-ptitle">
                  描いた絵を、動きのあるデジタル絵に
                </h3>
                <p>
                  園児の絵をスキャナーで取り込み、動きを加えたデジタル絵に仕上げました。
                </p>
              </div>
            </div>
            <div className="cd-point">
              <span className="cd-num">02</span>
              <div>
                <p className="cd-cat">NFTの発行</p>
                <h3 className="cd-ptitle">複製できないデジタル絵として発行</h3>
                <p>
                  ブロックチェーンを使い、描いた絵の現物と同じく「この世にひとつ」のデジタル絵として発行しました。
                </p>
              </div>
            </div>
            <div className="cd-point">
              <span className="cd-num">03</span>
              <div>
                <p className="cd-cat">展覧と返却</p>
                <h3 className="cd-ptitle">オンライン展覧会と保護者への返却</h3>
                <p>
                  オンラインで一定期間展示したあと、保護者がつくったウォレットへデジタル絵を返却する流れを設計しました。
                </p>
              </div>
            </div>
          </section>
          <section className="cd-sec">
            <h2>成果</h2>
            <p>
              卒園の思い出を、家族がいつまでも見返せる形で残す企画を実現しました。
            </p>
          </section>
        </div>
      </section>
      <section className="section ground">
        <div className="container">
          <h2 className="home-h2">
            <img src="/assets/icn_logo.svg" alt="" className="heading-icon" />
            ほかの事例<strong>Other Works</strong>
          </h2>
          <div className="case-grid">
            <Link className="case-card" to="/cases/anybound">
              <div className="case-img">
                <img
                  src="https://stg.leaps-inc.com/cms-admin/wp-content/uploads/2026/03/FV-1024x610.png"
                  alt=""
                />
              </div>
              <p className="case-meta">株式会社JTB</p>
              <h3>
                希少な旅行体験をブロックチェーンで流通させる共創プロジェクト「anyBOUND」
              </h3>
              <div className="case-tags">
                <span>エンタープライズ</span>
                <span>ブロックチェーン事業開発</span>
                <span>共創プロジェクト</span>
              </div>
            </Link>
            <Link className="case-card" to="/cases/kanda-curry">
              <div className="case-img is-cover">
                <span className="cover-en">NFT STAMP RALLY</span>
                <span className="cover-ja">スタンプラリー × NFT</span>
              </div>
              <p className="case-meta">広告代理店</p>
              <h3>
                スタンプラリーの思い出をNFTで残す「神田カレーグランプリ2025」
              </h3>
              <div className="case-tags">
                <span>イベント・観光</span>
                <span>ブロックチェーン事業開発</span>
              </div>
            </Link>
            <Link className="case-card" to="/cases/premience">
              <div className="case-img">
                <img src="/assets/images/case-premience.jpg" alt="" />
              </div>
              <p className="case-meta">株式会社JTB</p>
              <h3>
                JTBのラグジュアリー体験ブランド「プレミエンス」のロゴ制作とサイトリニューアル
              </h3>
              <div className="case-tags">
                <span>旅行・観光</span>
                <span>ブランディング・Web制作</span>
              </div>
            </Link>
          </div>
          <div className="more">
            <Link to="/cases">実績一覧を見る →</Link>
          </div>
        </div>
      </section>
      <ContactBand ground={false} />
    </main>
  );
}
